import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.custom.background.area,
    overflow: 'hidden',
    position: 'sticky',
    fallbacks: [{ position: '-webkit-sticky' }],
    top: 0,
    boxShadow: theme.shadows[25],
    zIndex: theme.zIndex.appBar,

    '& .tabs-container': {
      color: theme.palette.text.secondary,
    },
  },
  root: {
    ...theme.typography.caption,
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightMedium,
  },
  selected: {
    color: theme.palette.primary.main,
  },
}));

export default styles;
